<template>
  <form
    ref="form"
    :action="action"
    novalidate="novalidate"
    enctype="multipart/form-data"
    accept-charset="UTF-8"
    method="post"
  >
    <InputCsrf />
    <selector-imagen
      v-bind="$attrs"
      ref="selector"
      :can-save="true"
      @save="save"
    />
  </form>
</template>

<script>
/*
Componenete para cambiar la imagen de un registro. Incluye el formulario y
un botón para guardar la imagen directamente
 */
import SelectorImagen from './SelectorImagen.vue';

export default {
  components: {
    SelectorImagen,
  },
  props: {
    action: { type: String, required: true },
  },
  methods: {
    save() {
      this.$refs.form.submit();
    },
  },
};
</script>